import { render, staticRenderFns } from "./FormLeaders.vue?vue&type=template&id=71086127&scoped=true&"
import script from "./FormLeaders.vue?vue&type=script&lang=js&"
export * from "./FormLeaders.vue?vue&type=script&lang=js&"
import style0 from "./FormLeaders.vue?vue&type=style&index=0&id=71086127&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71086127",
  null
  
)

export default component.exports